export enum SubscriptionReviewerDecision {
  Approve = "approve",
  Reject = "reject",
  InProgress = "in_progress",
}
